const getBaseUrl = () => {
	const array = window.location.host.split(".");
	if (array[0] === "www") {
		array.shift()
	}
	array.shift();
	return array.join(".");
};

export default getBaseUrl;
